import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { UserService, StorageService, CookieService } from '@services/services.module';
import { MatBottomSheetRef } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '@constants/constants';

@Component({
  selector: 'app-session-timer',
  templateUrl: './session-timer.component.html',
  styleUrls: ['./session-timer.component.scss']
})
export class SessionTimerComponent implements OnInit {

  @ViewChild('span') span: ElementRef<HTMLElement>;
  countDown: number;

  constructor(
    private user_service: UserService,
    private _bottomSheetRef: MatBottomSheetRef<SessionTimerComponent>,
    private _user: UserService,
    private storage: StorageService,
    private cookie_service: CookieService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this._user.countDownSession$.subscribe(data => {
      if (data) {
        this.countDown = data;
        this.span.nativeElement.innerHTML = String(this.countDown);
      } else {
        this.logOut();
      }
    });
  }

  reLog() {
    this.user_service.refreshLogin().subscribe((data) => {
      if (data.token) {
        this.storage.set(Constants.UserData.TOKEN, data.token);
      }
    });
    this._bottomSheetRef.dismiss();
  }

  logOut(): void {
    this.user_service.logOut();
    this._bottomSheetRef.dismiss();
    this.modalService.dismissAll();
  }

}
